import alphanine from './alphanine';
import alyglo from './alyglo';
import coagadex from './coagadex';
import cutaquig from './cutaquig';
import fibryga from './fibryga';
import gammaked from './gammaked';
import gammaplex from './gammaplex';
import gamunex from './gamunex';
import koate from './koate';
import nuwiq from './nuwiq';
import octagam from './octagam';
import panzyga from './panzyga';
import prolastin from './prolastin';
import ryplazim from './ryplazim';
import wilate from './wilate';
import xembify from './xembify';
import yimmugo from './yimmugo';

export default {
  alphanine,
  alyglo,
  coagadex,
  cutaquig,
  fibryga,
  gammaked,
  gammaplex,
  gamunex,
  koate,
  nuwiq,
  octagam,
  panzyga,
  prolastin,
  ryplazim,
  wilate,
  xembify,
  yimmugo,
};
